import { isString } from 'lodash'
import React, { useMemo } from 'react'

import Popup, { IPopup } from '../Popup'

export interface IPopoverTrigger extends IPopup {
  /** Content of the popover */
  popover?: React.ReactNode
  /** Content of the popover */
  text?: React.ReactNode
  /** Content of the popover */
  element?: React.ReactNode
  /** Element that need popover */
  children?: React.ReactNode
}

const PopoverTrigger = (props: IPopoverTrigger): React.ReactElement => {
  const { popover, text, element, children, placement, ...IPopup } = props

  const item = useMemo(
    () => popover || element || text,
    [popover, element, text],
  )

  if (!item) {
    return children as React.ReactElement
  }

  return (
    <Popup
      trigger={isString(children) ? <div>{children}</div> : children}
      placement={placement}
      {...IPopup}
    >
      <div>{item}</div>
    </Popup>
  )
}

export default PopoverTrigger
